import { HOCRunStart, TutorialModal, UserProfile } from 'apps/BWW_PLAY_HUB/components';
import { AdSlots } from 'apps/BWW_PLAY_HUB/components/AdSlots';
import { Header } from 'apps/BWW_PLAY_HUB/components/Header';
import { Logout } from 'apps/BWW_PLAY_HUB/components/Logout';
import { store } from 'apps/BWW_PLAY_HUB/modules/store';
import { theme } from 'assets/css/theme';
import { Footer, HOCRegion, Menu, Preloader } from 'components';
import { MobileContainer } from 'apps/BWW_PLAY_HUB/components/MobileContainer';
import { HOCTermsChecking } from 'components/TermsChecking';
import { isLoggedIn } from 'modules/selectors/user';
import { BASE_URL, IS_UAT, retryFailLoad } from 'modules/utils';
import { RulesPage } from './pages/RulesPage';
import React, { lazy, Suspense } from 'react';
import { Provider, useSelector } from 'react-redux';
import { BrowserRouter as Router, Route, Switch } from 'react-router-dom';
import { ThemeProvider } from 'styled-components';

const PlayHub = lazy(retryFailLoad(() => import('apps/BWW_PLAY_HUB/pages/PlayHub')));
const PlayHubDebug = lazy(retryFailLoad(() => import('apps/BWW_PLAY_HUB/pages/PlayHubDebug')));
const Landing = lazy(retryFailLoad(() => import('pages/Landing')));

const Routes: React.FC = () => {
	const is_logged_in = useSelector(isLoggedIn);

	if (!is_logged_in) {
		return (
			<Suspense fallback={<Preloader/>}>
				<Route exact={true} path="/" component={Landing}/>
				<Route exact={true} path="/rules" component={RulesPage}/>
			</Suspense>
		)
	}

	return (
		<MobileContainer>
			<HOCRegion>
				<HOCTermsChecking>
					<Menu/>
					<Header userProfile={UserProfile}
							defaultOpenUserStats={true}
							tutorialType={'eco'}/>

					<Suspense fallback={<Preloader/>}>
						<Switch>
							<Route exact={true} path="/" component={PlayHub}/>

							{IS_UAT && (
								<Route exact={true} path="/debug" component={PlayHubDebug}/>
							)}

							<Route exact={true} path="/landing" component={Landing}/>
							<Route exact={true} path="/rules" component={RulesPage}/>
							<Route exact={true} path="/logout" component={Logout}/>

						</Switch>
					</Suspense>
					<AdSlots/>
					<TutorialModal/>
					<Footer/>
				</HOCTermsChecking>
			</HOCRegion>
		</MobileContainer>
	)
}

const ProjectIndex: React.FC = () => (
	<Provider store={store}>
		<Router basename={BASE_URL}>
			<ThemeProvider theme={theme}>
				<HOCRunStart>
					<Routes/>
				</HOCRunStart>
			</ThemeProvider>
		</Router>
	</Provider>
);


/**
 * Disabled due to inability to configure fractal-control-default-export
 */
// tslint:disable-next-line:fractal-control-default-export
export default ProjectIndex;
